import React, { useState } from "react";
import I from "./Icon";

export default function SettingsPanel({
  onClose,
  onNav
}) {
  const [activeTab, setActiveTab] = useState("roles");

  const roles = [
    {
      name: "Super Admin",
      users: 1,
      perms: ["All access"]
    },
    {
      name: "Exam Manager",
      users: 3,
      perms: ["Exams", "Centers", "Reports"]
    },
    {
      name: "School Coordinator",
      users: 8,
      perms: ["Schools", "Teachers", "Students"]
    },
    {
      name: "Finance Officer",
      users: 2,
      perms: ["Fees", "Reports"]
    }
  ];

  const templates = [
    {
      name: "Manthan Category",
      type: "Manthan",
      duration: "120 min",
      questions: 80
    },
    {
      name: "Shabhas Category",
      type: "Shabhas",
      duration: "180 min",
      questions: 100
    },
    {
      name: "ICS Category",
      type: "ICS",
      duration: "90 min",
      questions: 60
    },
    {
      name: "Proficiency Category",
      type: "Proficiency",
      duration: "60 min",
      questions: 50
    }
  ];

  const [selTpl, setSelTpl] = useState(0);

  const [prefs, setPrefs] = useState({
    emailNotif: true,
    smsNotif: true,
    autoReport: false,
    darkMode: false,
    twoFactor: true
  });

  return (
    <div className="ov-panel" onClick={onClose}>
      <div
        className="ov-panel-inner wide"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="dhdr">
          <div>
            <div
              style={{
                fontWeight: 700,
                fontSize: 16
              }}
            >
              Settings
            </div>

            <div
              style={{
                fontSize: 12,
                color: "var(--t3)",
                marginTop: 2
              }}
            >
              Roles, templates & system preferences
            </div>
          </div>

          <div
            style={{
              display: "flex",
              gap: 8
            }}
          >
            <button
              className="btn bp bsm"
              onClick={() => onNav("settings")}
            >
              Full Settings
            </button>

            <button
              className="close-btn"
              onClick={onClose}
            >
              <I n="x" s={14} />
            </button>
          </div>
        </div>

        <div
          style={{
            padding: "12px 20px",
            borderBottom: "1px solid var(--bd)"
          }}
        >
          <div
            className="tabs"
            style={{ marginBottom: 0 }}
          >
            {[
              {
                id: "roles",
                icon: "role",
                label: "Roles & Permissions"
              },
              {
                id: "templates",
                icon: "template",
                label: "Exam Masters"
              },
              {
                id: "prefs",
                icon: "pref",
                label: "System Preferences"
              }
            ].map((t) => (
              <button
                key={t.id}
                className={`tab${
                  activeTab === t.id ? " on" : ""
                }`}
                onClick={() => setActiveTab(t.id)}
              >
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 6
                  }}
                >
                  <I n={t.icon} s={13} />
                  {t.label}
                </span>
              </button>
            ))}
          </div>
        </div>

        <div
          style={{
            flex: 1,
            overflowY: "auto",
            padding: "20px"
          }}
        >
          {activeTab === "roles" && (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: 16
                }}
              >
                <div
                  style={{
                    fontWeight: 700,
                    fontSize: 14
                  }}
                >
                  Role Management
                </div>

                <button className="btn bp bsm">
                  <I n="plus" s={13} c="#fff" />
                  Add Role
                </button>
              </div>

              {roles.map((r, i) => (
                <div
                  key={i}
                  style={{
                    background: "var(--bg2)",
                    border: "1.5px solid var(--bd)",
                    borderRadius: "var(--r2)",
                    padding: "14px 16px",
                    marginBottom: 10
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: 8
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 10
                      }}
                    >
                      <div
                        style={{
                          width: 36,
                          height: 36,
                          background: "var(--pl)",
                          borderRadius: 8,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center"
                        }}
                      >
                        <I
                          n="shield"
                          s={17}
                          c="var(--p)"
                        />
                      </div>

                      <div>
                        <div
                          style={{
                            fontWeight: 700,
                            fontSize: 13.5
                          }}
                        >
                          {r.name}
                        </div>

                        <div
                          style={{
                            fontSize: 11.5,
                            color: "var(--t3)"
                          }}
                        >
                          {r.users} user
                          {r.users !== 1 ? "s" : ""}
                        </div>
                      </div>
                    </div>

                    <button className="btn bg_ bsm">
                      <I n="edit" s={12} />
                      Edit
                    </button>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      gap: 5,
                      flexWrap: "wrap"
                    }}
                  >
                    {r.perms.map((p) => (
                      <span
                        key={p}
                        className="chip"
                        style={{ fontSize: 10 }}
                      >
                        {p}
                      </span>
                    ))}
                  </div>
                </div>
              ))}
            </>
          )}

          {activeTab === "templates" && (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: 16
                }}
              >
                <div
                  style={{
                    fontWeight: 700,
                    fontSize: 14
                  }}
                >
                  Exam Master
                </div>

                <button className="btn bp bsm">
                  <I n="plus" s={13} c="#fff" />
                  New Category
                </button>
              </div>

              <div className="g2">
                {templates.map((t, i) => (
                  <div
                    key={i}
                    className={`template-card${
                      selTpl === i
                        ? " selected"
                        : ""
                    }`}
                    onClick={() => setSelTpl(i)}
                  >
                    {selTpl === i && (
                      <div
                        style={{
                          position: "absolute",
                          top: 10,
                          right: 10
                        }}
                      >
                        <I
                          n="check"
                          s={14}
                          c="var(--p)"
                        />
                      </div>
                    )}

                    <div
                      style={{
                        width: 36,
                        height: 36,
                        background:
                          selTpl === i
                            ? "var(--pm)"
                            : "var(--bg)",
                        borderRadius: 8,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginBottom: 10
                      }}
                    >
                      <I
                        n="template"
                        s={17}
                        c={
                          selTpl === i
                            ? "var(--p)"
                            : "var(--t2)"
                        }
                      />
                    </div>

                    <div
                      style={{
                        fontWeight: 700,
                        fontSize: 13,
                        marginBottom: 4
                      }}
                    >
                      {t.name}
                    </div>

                    <div
                      style={{
                        fontSize: 11.5,
                        color: "var(--t3)",
                        marginBottom: 8
                      }}
                    >
                      {t.type} · {t.duration} ·{" "}
                      {t.questions} Qs
                    </div>

                    <span
                      className="chip"
                      style={{ fontSize: 10 }}
                    >
                      {t.type}
                    </span>
                  </div>
                ))}
              </div>
            </>
          )}

          {activeTab === "prefs" && (
            <>
              <div
                style={{
                  fontWeight: 700,
                  fontSize: 14,
                  marginBottom: 16
                }}
              >
                System Preferences
              </div>

              {[
                [
                  "Email Notifications",
                  "Receive alerts via email",
                  "emailNotif"
                ],
               
                [
                  "Two-factor Authentication",
                  "Enhanced login security",
                  "twoFactor"
                ]
              ].map(([title, sub, key]) => (
                <div
                  key={key}
                  className="perm-row"
                >
                  <div>
                    <div
                      style={{
                        fontSize: 13.5,
                        fontWeight: 600
                      }}
                    >
                      {title}
                    </div>

                    <div
                      style={{
                        fontSize: 12,
                        color: "var(--t3)"
                      }}
                    >
                      {sub}
                    </div>
                  </div>

                  <div
                    className="tog"
                    style={{
                      background: prefs[key]
                        ? "var(--p)"
                        : "var(--bd)"
                    }}
                    onClick={() =>
                      setPrefs((p) => ({
                        ...p,
                        [key]: !p[key]
                      }))
                    }
                  >
                    <div
                      className="tok"
                      style={{
                        left: prefs[key]
                          ? 21
                          : 3
                      }}
                    />
                  </div>
                </div>
              ))}

              <button
                className="btn bp"
                style={{ marginTop: 20 }}
              >
                <I n="check" s={14} c="#fff" />
                Save Preferences
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}